import { render, staticRenderFns } from "./ReportAvhandling.vue?vue&type=template&id=38e68d74&scoped=true&"
import script from "./ReportAvhandling.vue?vue&type=script&lang=js&"
export * from "./ReportAvhandling.vue?vue&type=script&lang=js&"
import style0 from "./ReportAvhandling.vue?vue&type=style&index=0&id=38e68d74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e68d74",
  null
  
)

export default component.exports